import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AttendancePrognoseDto } from "app/models/dtos/attendance-prognose.dto";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { ConfigurationService } from "./configuration.service";
import { HttpService } from "./http.service";

@Injectable()
export class AttendanceService extends BaseService {
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    prognoseAttendance(ticketPrice: number, teamId: number): Observable<AttendancePrognoseDto> {
        let params = new HttpParams();
        params = params.append('ticketPrice', ticketPrice.toString());
        params = params.append('teamId', teamId.toString());

        return this.httpService.get<AttendancePrognoseDto>(this.apiUrl + 'attendance/prognose', params)
    }
}